import ninegrid from "../index.js";

export class ngMatrixManager
{
	#owner;
	//#oldrow;
	#newrow;
	#headRows;
	#bodyRows;
	#footRows;
	
	constructor(owner) {
		
		this.#owner = owner;
		
		//this.#oldrow = -1;
		this.#newrow = -1;
		this.#headRows = [];
		this.#bodyRows = [];
		this.#footRows = [];

		
		this.head = {
			attr	: (matrixRow, key, value)	=> { return this.attr	("head", matrixRow, key, value); },
			height	: (matrixRow, value)		=> { return this.height	("head", matrixRow, value); },
		};
		
		this.body = {
			attr	: (matrixRow, key, value)		=> { return this.attr	("body", matrixRow, key, value); },
			height	: (matrixRow, value)			=> { return this.height	("body", matrixRow, value); },
			height2	: (records, matrixRow, value)	=> { return this.height2(records, "body", matrixRow, value); },
		};
		
		this.foot = {
			attr	: (matrixRow, key, value)	=> { return this.attr	("foot", matrixRow, key, value); },
			height	: (matrixRow, value)		=> { return this.height	("foot", matrixRow, value); },
		};
	}
	
	get row() {
		return this.#newrow;
	};
	set row(v) {

		//this.#oldrow = this.#newrow;
		this.#newrow = parseInt(v);
		
		if (this.#owner.selection.selectedStartRow == this.#owner.selection.selectedEndRow) {
			this.#owner.selection.selectedStartRow = this.#owner.selection.selectedEndRow = this.#owner.selection.startRow = this.#newrow;
		}
	}

	getTotalHeight = () => {
		return this.#owner.data.get().reduce((total, item) => {
			return total + item.__ng.height.reduce((sum, h) => sum + h, 0);
		}, 0);
	};

	getHeight = (matrixRow)	=> {
				
		const row = parseInt(matrixRow / this.#owner.template.length);
		if (row < 0 || row >= this.#owner.data.count()) return 32;
		const o = this.#owner.data.__ng(row);
	
		if (!o) return 32;


		return o.height[parseInt(matrixRow % this.#owner.template.length)];
	};
	
	setHeight = (matrixRow, v)	=> {
		this.#owner.data.get(parseInt(matrixRow / this.#owner.template.length)).__ng.height[parseInt(matrixRow % this.#owner.template.length)] = v;
	};
	
	/** attribute */
	#element2Row = (matrixRow) => {
		
		if (typeof matrixRow == "object") {
			if (matrixRow.tagName == "TR") {

				return parseInt(matrixRow.getAttribute("data-row")) * this.#owner.template.length + matrixRow.sectionRowIndex % this.#owner.template.length;
			}
		}
		
		return matrixRow;
	}
	
	attr = (group, matrixRow, key, value) => {
		
		matrixRow = this.#element2Row(matrixRow);

		var dataRow = parseInt(matrixRow / this.#owner.template.length);
		var rowid = this.#owner.data.get(dataRow, "rowid");
		var subrow = matrixRow % this.#owner.template.length;
		//matrixRow += this.#owner.dataManager.viewRecords.rawIndex * this.#owner.template.length;
		
		var rows = ninegrid.decode(group, "head", this.#headRows, "foot", this.#footRows, this.#bodyRows);
		var idx = rows.findIndex(o => o.rowid == rowid && o.subrow == subrow);

		
		if (value) {
			if (idx < 0) {
				var o = { "rowid": rowid, "subrow": subrow, cells: [] };
				o[key] = value;
				
				rows.push(o);

				//rows.sort( (a, b) => { return a.rowIndex - b.rowIndex; } );
			}
			else {
				rows[idx][key] = value;
			}
		}
		else {
			return (idx < 0) ? null : rows[idx][key];
		}
	};
	
	height = (group, matrixRow, value) => {
		var h = this.attr(group, matrixRow, "height", value);
		
		//if (!h) h = $(this.#owner.template[matrixRow % this.#owner.template.length]).height();
		if (!h) h = $(this.#owner.template[this.#element2Row(matrixRow) % this.#owner.template.length]).height();
		
		return h;
	};
	
	attr2 = (records, group, matrixRow, key, value) => {
		
		matrixRow = this.#element2Row(matrixRow);
		
		var dataRow = parseInt(matrixRow / this.#owner.template.length);
		//var rowid = this.#owner.data.get(dataRow, "rowid");
		var rowid = records && records.hasOwnProperty("rowid") ? records[dataRow].rowid : null;
		var subrow = matrixRow % this.#owner.template.length;
		//matrixRow += this.#owner.dataManager.viewRecords.rawIndex * this.#owner.template.length;
		

		var rows = ninegrid.decode(group, "head", this.#headRows, "foot", this.#footRows, this.#bodyRows);
		var idx = rows.findIndex(o => o.rowid == rowid && o.subrow == subrow);
		

		if (value) {
			if (idx < 0) {
				var o = { "rowid": rowid, "subrow": subrow, cells: [] };
				o[key] = value;
				
				rows.push(o);

				//rows.sort( (a, b) => { return a.rowIndex - b.rowIndex; } );
			}
			else {
				rows[idx][key] = value;
			}
		}
		else {
			return (idx < 0) ? null : rows[idx][key];
		}
	};
	
	height2 = (records, group, matrixRow, value) => {
		var h = this.attr2(records, group, matrixRow, "height", value);
		
		//if (!h) h = $(this.#owner.template[matrixRow % this.#owner.template.length]).height();
		if (!h) h = $(this.#owner.template[this.#element2Row(matrixRow) % this.#owner.template.length]).height();
		
		return h;
	};	
}
